module.exports = __webpack_public_path__ + "img/Patch16-1.9f7993e1.webp";